module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/cases/a2_8dbd9329c9c143de2070418450a0f081.png";